import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { KindOfOrder } from "../../../../types/enums";
import { NoteRecipientsResult } from "../types/NoteRecipientsResult";

export const useGetNoteRecipients = (companyIDs: number[], kindOfOrder: KindOfOrder, enabled: boolean) => {

    const { data, isLoading } = useQuery({
        queryKey: ['note-recipients', companyIDs, kindOfOrder],
        queryFn: async () => await apiClient.post('note/recipients',
            { companyIDs: companyIDs, kindOfOrder: kindOfOrder }) as NoteRecipientsResult,
        enabled: enabled
    });

    return {
        data,
        isLoading
    };
};
